import { v4 as uuidv4 } from "uuid";
export async function loader() {
  const clientId = uuidv4();

  return {
    url: `${import.meta.env.VITE_CHAT_API}/ws/${clientId}`,
    clientId: clientId,
  };
}

export type LoaderData = Awaited<ReturnType<typeof loader>>;
